module.exports = __webpack_public_path__ + "img/snel.cf87b179.svg";